<template>
	<div id="app">
		<!-- 此处排除的是根据组件中的name，不是路由中name -->
		<keep-alive :exclude="['Login']">
			<router-view v-on:footer="footer" />
		</keep-alive>
		<default-footer v-show="footer_show"></default-footer>
		 
	</div>
</template>

<script>
	import DefaultFooter from "@/components/DefaultFooter";
	import { Message } from 'element-ui'
	export default {
		name: 'App',
		components: {
			DefaultFooter
		},
		data() {
			return {
				footer_show: false,
				clock:undefined,
			}
		},
		beforeDestroy() {
			localStorage.clear();
		},
		mounted() {
			
		},
		destroyed () {
			
		},
		methods: {
			//是否显示底部
			footer: function(bool) {
				this.footer_show = bool;
			},
		}
	}
</script>
